const PaymentPageStyles = (theme) => ({
    linkButton: {
      fontSize: "1.2rem",
    },
    fullHeight: {
      height: "100%",
    },
  });
  export default PaymentPageStyles;
  